import { Injectable } from '@angular/core';


export class ProgressbarConfig {
  /** if `true` changing value of progress bar will be animated */
  animate: Boolean = false;
  /** maximum total value of progress element */
  max = 100;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
